// extracted by mini-css-extract-plugin
export default {"buttonAdd":"side-block-groups_buttonAdd__+LBFI","buttonAddIcon":"side-block-groups_buttonAddIcon__kl0Co"};